// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f32067b","732":"b990ded6","977":"a05ce9be"}[chunkId] + ".chunk.js";
};